export const tableLabel = [
  {
    label: '原材料库存订单',
    param: 'seqNo',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '供应商名称',
    param: 'supplierCompanyName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '下单人',
    param: 'creatorRealName',
    align: 'center',
    minWidth: 120,
  },
  {
    label: '采购日期',
    param: 'purchaseDate',
    align: 'center',
    minWidth: 110,
  },
  {
    label: '创建日期',
    param: 'createTime',
    align: 'center',
    minWidth: 110,
  },
  {
    label: '单据金额',
    param: 'price',
    align: 'center',
    minWidth: 110,
    slot: 'price',
  },
  {
    label: 'AI审查建议结果',
    param: 'aiCheckResult',
    align: 'center',
    minWidth: 110,
    slot: 'aiCheckResult',
    headerSlot: 'aiCheckResultHeader',
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '160',
    slot: 'handle',
    minWidth: 100,
  },
];

export const formattedPrice = (price) => {
  if (!price) return '';
  return new Intl.NumberFormat('zh-CN', {
    style: 'currency',
    currency: 'CNY',
  }).format(price);
};

export const fieldList = [
  {
    label: '原材料库存订单',
    type: 'input',
    value: 'seqNo',
  },
  {
    label: '供应商名称',
    type: 'input',
    value: 'supplierCompanyName',
  },
  {
    label: '下单人',
    type: 'input',
    value: 'creatorRealName',
  },
];

function padZero(num) {
  return num < 10 ? `0${num}` : num;
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1); // 月份从0开始，所以需要加1
  const day = padZero(date.getDate());
  const hours = padZero(date.getHours());
  const minutes = padZero(date.getMinutes());
  const seconds = padZero(date.getSeconds());

  return `${year}-${month}-${day}`;
}

export function getHalfYearRange() {
  // 获取当前日期时间
  const now = new Date();

  // 计算6个月前的日期时间
  const sixMonthsAgo = new Date(
    now.getFullYear(),
    now.getMonth() - 6,
    now.getDate(),
    now.getHours(),
    now.getMinutes(),
    now.getSeconds()
  );

  // 调整月份减去6可能导致的年份变化
  if (sixMonthsAgo.getDate() !== now.getDate()) {
    // 如果计算后的日期不是同一天（可能是由于月份天数不同），调整为上个月的最后一天
    sixMonthsAgo.setDate(0); // 设置为上个月的最后一天
  }

  // 格式化日期时间为自定义格式
  const startTime = formatDate(sixMonthsAgo);
  const endTime = formatDate(now);

  return [startTime, endTime];
}

const createTime = getHalfYearRange();
const submitTime = getHalfYearRange();

export const listQuery = {
  orderNo: '',
  companyName: '',
  start: '',
  end: '',
  createDateBegin: '',
  createDateEnd: '',
  createTime,
  remark: null,
  purchaseCompany: null,
  submitTime,
  isDoC: null,
  purchaseRequestType: null,
  erpNo: null,
  pageNum: 1,
  pageSize: 10,
};
export const listTypeInfo = {
  dataTypes: [
    { name: '全部', id: '' },
    { name: '订货函', id: 1 },
    { name: '中选通知', id: 2 },
    { name: '中标通知', id: 3 },
  ],
  stockTypes: [
    { name: '全部', id: '' },
    { name: '询比价', id: 1 },
    { name: '公开招标', id: 2 },
    { name: '邀请招标', id: 3 },
    { name: '框架协议', id: 4 },
  ],
  purchaseRequestTypeList: [
    { id: null, name: '全部' },
    { id: 1, name: '标准' },
    { id: 2, name: '寄售' },
  ],
  isDoCList: [
    { id: null, name: '全部' },
    { id: 0, name: '款到发货' },
    { id: 1, name: '货到付款' },
  ],
};

// 左侧石化采购意向单搜索
export const stockDrawerFieldList = [
  {
    label: '采购方案编号',
    type: 'input',
    value: 'stockAffirmId',
  },
  {
    label: '采购方案名称',
    type: 'input',
    value: 'stockAffirmName',
  },
  {
    label: '采购方式',
    type: 'select',
    value: 'stockType',
    list: 'stockTypes',
  },
  {
    label: '类型',
    type: 'select',
    value: 'dataType',
    list: 'dataTypes',
  },
  {
    label: '创建时间',
    type: 'date',
    value: 'createTime',
    dateType: 'daterange',
    valueFormat: 'yyyy-MM-dd',
    defaultTime: ['00:00:00', '23:59:59'],
  },
  {
    label: 'ERP订单号',
    type: 'input',
    value: 'erpNo',
  },
  {
    label: '备注',
    type: 'input',
    value: 'remark',
  },
];
// 左侧石化商城订单搜索
export const mallOrderFieldList = [
  { label: '石化商城订单编号', type: 'input', value: 'orderNo' },
  { label: '采购商名称', type: 'input', value: 'purchaseCompany' },
  { label: '结算方式', type: 'select', value: 'isDoC', list: 'isDoCList' },
  {
    label: '订单类型',
    type: 'select',
    value: 'purchaseRequestType',
    list: 'purchaseRequestTypeList',
  },
  {
    label: '下单时间',
    value: 'submitTime',
    type: 'date',
    dateType: 'daterange',
    format: 'yyyy-MM-dd',
    valueFormat: 'yyyy-MM-dd',
  },
  { label: 'ERP订单号', type: 'input', value: 'erpNo' },
  { label: '备注', type: 'input', value: 'remark' },
];

// 左侧石化采购意向单列表
export const leftStockDrawerTableLabel = [
  {
    label: 'stockAffirmHeader',
    param: 'stockAffirmId',
    align: 'center',
    header: true,
    minWidth: '150px',
    tooltip: true,
  },
  {
    label: 'erpNoHeader',
    param: 'erpNo',
    align: 'center',
    header: true,
    minWidth: '130px',
  },
  {
    label: '采购方式',
    param: 'stockType',
    align: 'center',
    minWidth: 90,
    hide: true,
    render(row) {
      const data = {
        1: '询比价',
        2: '公开招标',
        3: '邀请招标',
        4: '框架协议',
      };
      return data[row.stockType];
    },
  },
  {
    label: '类型',
    param: 'dataType',
    align: 'center',
    minWidth: 100,
    render(row) {
      const { name } = listTypeInfo.dataTypes.find(
        (item) => item.id === row.dataType
      );
      return name;
    },
  },
  {
    label: '石化采购意向单名称',
    param: 'stockAffirmName',
    align: 'center',
    minWidth: 120,
    tooltip: true,
  },
  {
    label: '备注',
    param: 'remark',
    align: 'center',
    minWidth: 180,
    tooltip: true,
  },
  {
    label: '操作',
    width: 90,
    slot: 'operate',
    align: 'center',
  },
];
// 左侧石化商城订单列表
export const leftMallOrderTableLabel = [
  { label: '订单编号', param: 'orderNo', align: 'center', width: '180' },
  { label: 'ERP订单号', param: 'erpNo', align: 'center', width: '120' },
  {
    label: '采购商名称',
    param: 'purchaseCompany',
    align: 'center',
    width: '160',
    tooltip: true,
  },
  { label: '下单时间', param: 'submitTime', align: 'center', width: '160' },
  {
    label: '备注',
    param: 'remark',
    align: 'center',
    width: '140',
    tooltip: true,
  },
  {
    label: '操作',
    param: '',
    align: 'center',
    slot: 'operate',
    fixed: 'right',
    flag: 'two',
  },
];

export const rightOrderDrawerTableLabel = [
  {
    label: '石化采购意向单编号',
    param: 'stockAffirmId',
    tooltip: true,
    align: 'center',
    minWidth: 140,
    slot: 'idOrNo',
  },
  {
    label: '类型',
    param: 'dataType',
    align: 'center',
    minWidth: 100,
    render: (row) => {
      const obj = {
        1: '订货函',
        2: '中选通知',
        3: '中标通知',
      };
      // row.dataType 有值展示石化采购意向单得内容，没值展示石化商城订单得内容
      return row.dataType ? obj[Number(row.dataType)] : '石化商城订单';
    },
  },
  {
    label: '石化采购意向单名称',
    param: 'stockAffirmName',
    align: 'center',
    tooltip: true,
    minWidth: 120,
  },
];

export const supplierListQuery = {
  companyId: '',
  companyName: '',
  pageNum: 1,
  pageSize: 10,
};

export const supplierFieldList = [
  // {
  //   label: '供应商id',
  //   value: 'companyId',
  //   type: 'inputnumber'
  // },
  {
    label: '供应商名称',
    type: 'input',
    value: 'companyName',
  },
];

export const supplierLabel = [
  {
    label: '选择',
    align: 'center',
    width: 60,
    slot: 'radio',
  },
  // {
  //   label: '供应商id',
  //   param: 'companyId',
  //   align: 'center',
  //   minWidth: 140,
  // },
  {
    label: '供应商名称',
    param: 'companyName',
    tooltip: true,
    align: 'center',
    minWidth: 140,
  },
];

export const productTableLabel = [
  {
    label: '商品名称',
    param: 'product',
    align: 'center',
    minWidth: 220,
    slot: 'product',
    maxLength: 100,
  },
  {
    label: '需求数量',
    param: 'quantity',
    align: 'center',
    minWidth: 120,
    slot: 'quantity',
    maxLength: 10,
  },
  {
    label: '单价',
    param: 'price',
    align: 'center',
    minWidth: 120,
    slot: 'price',
    maxLength: 10,
  },
  {
    label: '计量单位',
    param: 'unit',
    align: 'center',
    minWidth: 130,
    slot: 'unit',
    maxLength: 10,
  },
  {
    label: '规格型号',
    param: 'specs',
    align: 'center',
    minWidth: 130,
    slot: 'specs',
  },
  {
    label: '品牌',
    param: 'brand',
    align: 'center',
    minWidth: 130,
    slot: 'brand',
    maxLength: 100,
  },
  {
    label: '商品描述',
    param: 'description',
    align: 'center',
    minWidth: 220,
    slot: 'description',
    maxLength: 100,
  },
  {
    label: '商品目录',
    param: 'category',
    align: 'center',
    minWidth: 150,
    slot: 'category',
    maxLength: 100,
  },
  {
    label: '小计',
    param: 'needPay',
    align: 'center',
    minWidth: 150,
    fixed: 'right',
    slot: 'needPay',
  },
  {
    label: '操作',
    align: 'center',
    width: 80,
    slot: 'handle',
    fixed: 'right',
  },
];

const isValidDecimal = (value) => {
  const regex = /^\d+(\.\d{1,2})?$/;
  return regex.test(value);
};
export const validatePrice = (rule, value, callback) => {
  const regex = /^[\d.]+$/; // 只能是数字和小数点
  if (value && !regex.test(value)) {
    callback(new Error('只能输入数字'));
  } else if (value && !isValidDecimal(value)) {
    callback(new Error('最多2位小数'));
  } else {
    callback();
  }
  return false;
};
const checkNumber = (requiredQuantity) => {
  const numberReg = /^-?\d+(\.\d{1,3})?$/;
  return numberReg.test(requiredQuantity);
};
export const validateQuantity = (rule, value, callback) => {
  if (value <= 0) {
    return callback(new Error(`需求数量需大于0`));
  }
  if (!checkNumber(value)) {
    callback(new Error('最多3位小数'));
  } else {
    callback();
  }
  return false;
};

// 关联石化采购意向单 label

export const affirmLabel = [
  {
    label: '采购方案编号',
    param: 'stockAffirmId',
    align: 'center',
    tooltip: true,
  },
  {
    label: 'ERP订单号',
    param: 'erpNo',
    align: 'center',
  },
  {
    label: '采购方式',
    param: 'stockType',
    align: 'center',
    render(row) {
      const { name = '' } =
        listTypeInfo.stockTypes.find((item) => item.id === row.stockType) || {};
      return name;
    },
  },
  {
    label: '采购方案名称',
    param: 'stockAffirmName',
    align: 'center',
    tooltip: true,
  },
  {
    label: '类型',
    param: 'dataType',
    align: 'center',
    render(row) {
      const { name = '' } =
        listTypeInfo.dataTypes.find((item) => item.id === row.dataType) || {};
      return name;
    },
  },
  {
    label: '备注',
    align: 'center',
    param: 'remark',
    tooltip: true,
  },
  {
    label: '操作',
    align: 'center',
    slot: 'handle',
  },
];

export const detailLabel = [
  {
    label: '计量单位',
    param: 'unit',
    align: 'center',
  },
  {
    label: '数量',
    param: 'numCount',
    align: 'center',
  },
  {
    label: '物资描述',
    param: 'prodName',
    align: 'center',
    tooltip: true,
  },
];
